import type { ReactNode } from "react";

export function CanvasStatusBanner({ children }: { children: ReactNode }) {
  return (
    <div className="pointer-events-none absolute inset-x-0 top-3 z-20 flex justify-center px-3">
      <span className="rounded-full border border-border bg-card/95 px-4 py-1.5 text-sm font-semibold text-foreground shadow-md backdrop-blur-sm">
        {children}
      </span>
    </div>
  );
}
